import {useSelector} from "react-redux";
import TableComponent from "../../components/table-component";

const ProductList = () => {
    const {beautyEmptiesDetail} = useSelector(state => state.beautyEmptiesReducer)
    const columns = [
        {
            name: 'Product',
            width: '70%',
            classNameHeader: 'pl-20',
            render: (record) => (
                <div className={"row items-center space-x-4 font-regular text-monstera pl-5 py-4"}>
                    <img src={record?.image?.url} alt={record?.image?.alt_text} className={"w-12"}/>
                    <p>{record.name}</p>
                </div>
            )
        }, {
            name: 'QTY',
            dataIndex: 'quantity',
            classNameHeader: 'text-center',
            render: (quantity) => (
                <p className={"font-regular text-forged-steel text-center"}>{quantity} Pcs</p>
            )
        }
    ]

    return (
        <div className={"col space-y-3 font-regular"}>
            <p className={"pl-5 font-Montserrat-Bold text-monstera text-sm"}>Product Item</p>
            <TableComponent
                columns={columns}
                tableClassName={"font-Regular"}
                headerClassName={"bg-windmill-wings font-semibold text-left text-monstera h-8"}
                dataSource={beautyEmptiesDetail?.products ?? []}
                pagination={false}
                isHoverStyle={false}
            />
        </div>
    )
}

export default ProductList
